import * as angular from "angular";
import * as moment from "moment";
import * as _ from "lodash";
import AddBatchSummaryName, { openAddBatchSummary } from "./addBatchSummary.controller";
import { States, Strings } from "../../shared/config/constant.module";
import template from './batchSummary.tpl.html';
import { Plant } from "../../models/navigation";
import { apsCommon } from "../../shared/dto/aps.common";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import BatchSummaryServiceName, { BatchSummaryService } from "../../services/batches/batchSummary.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import UIUtilityServiceName, { UIUtilityService } from "../../services/utility/uiUtility.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import JobServiceName, { JobService } from "../../services/jobs/job.service";
import CommoditiesServiceName, { CommoditiesService } from "../../services/batches/commodities.service";
import { HolidaysService } from "../../services/holidays/holidays.service";

let requires = [AddBatchSummaryName, /*UpdateBatchSummaryName*/, LoaderServiceName, NotifyServiceName, BatchSummaryServiceName,
  AuthDataServiceName, UIUtilityServiceName, NavigationServiceName, JobServiceName, CommoditiesServiceName];

interface BatchSummaryController {
  batchSummary: apsViewModels.BatchSummaryItem[];
  batchData: apsViewModels.BatchSummaryItem;
  plants: Plant[];
  selectedPlant: Plant;
  plantChanged(): void;
  filterChanged(): void;
  dateChanged(): void;
  add(): void;
  edit(instance: apsViewModels.BatchSummaryItem): void;
  remove(instance: apsViewModels.BatchSummaryItem): void;
  getmeltedTons(): number;
  exportToCsv(): void;
  canEdit: boolean;
}

class BatchSummaryCtrl implements BatchSummaryController {
  year: number;
  productionDate: Date;
  formattedReportDate: string;
  minDate: string;
  maxDate: string;
  batchSummary: apsViewModels.BatchSummaryItem[];
  batchData: apsViewModels.BatchSummaryItem;
  plants: Plant[];
  selectedPlant: Plant;
  currentselectedPlant: Plant;
  tanks: apsCommon.IdAndName[];
  selectedTank: apsCommon.IdAndName;
  currentselectedTank: apsCommon.IdAndName;
  canEdit: boolean;
  holidays: apsViewModels.Holiday[];

  private loaderService: LoaderService;
  private batchSummaryService: BatchSummaryService;
  private uiUtilityService: UIUtilityService;
  private notifyService: NotifyService;
  private $modal: mm.foundation.modal;
  private $q: angular.IQService;

  constructor(
    loaderService: LoaderService,
    batchSummaryService: BatchSummaryService,
    jobService: JobService,
    $q: angular.IQService,
    navigationService: NavigationService,
    authDataService: AuthDataService,
    uiUtilityService: UIUtilityService,
    notifyService: NotifyService,
    $modal: mm.foundation.modal,
    holidaysService: HolidaysService
  ) {
    this.loaderService = loaderService;
    this.batchSummaryService = batchSummaryService;
    this.uiUtilityService = uiUtilityService;
    this.notifyService = notifyService;
    const holidayService = holidaysService;
    this.$modal = $modal;
    this.$q = $q;
    this.productionDate = moment().add(-1, 'days').toDate();
    this.maxDate = moment().format(Strings.ISO_DATE_FORMAT);

    let promises = [];
    promises.push(navigationService.getNavigation().then(nav => {
      let plants = nav.plants();
      this.plants = plants;

      if (nav.selectedPlant && _.includes(this.plants, nav.selectedPlant)) {
        this.selectedPlant = nav.selectedPlant;
      } else {
        this.selectedPlant = _.first(this.plants);
      }

      return this.plantChanged();
    }));

    promises.push(holidayService.getHolidays(moment().year())
            .then(h => {
              this.holidays = h;
              this.canEdit = this.canBatchBeEdited();
            }));

    this.loaderService.loadingPromise(this.$q.all(promises));
  }

  private plantChangedPrivate(): angular.IPromise<any> {
    this.tanks = this.selectedPlant.tanks;
    this.selectedTank = _.first(this.tanks);
    let promises = [];
    return this.$q.all(promises);
  }


  private loadBatchSummary(): angular.IPromise<any> {
    let promises = [];
    this.currentselectedPlant = this.selectedPlant;
    this.currentselectedTank = this.selectedTank;
    this.formattedReportDate = moment(this.productionDate).format("MM/DD/YYYY");
    this.batchSummary= [];
    if (this.selectedPlant && this.selectedTank && this.productionDate)
      promises.push(this.batchSummaryService
        .get(this.selectedPlant.id, this.selectedTank.id, moment(this.productionDate).format(Strings.ISO_DATE_FORMAT))
        .then(batchSummary => {
          this.batchSummary = batchSummary;
        }));

    return this.$q.all(promises);
  }

  plantChanged(): void {
    this.loaderService.loadingPromise(this.plantChangedPrivate());
  }

  filterChanged(): void {
    this.loaderService.loadingPromise(this.loadBatchSummary());
    this.canEdit = this.canBatchBeEdited();
  }
  dateChanged(): void{
    this.canEdit = this.canBatchBeEdited();
  }
  getmeltedTons(): number {
    var meltedtons: number = 0;
    this.batchSummary.filter(x=>x.isChild == false && x.binName !== 'Batch').forEach(a => meltedtons += a.tons);
    this.batchData = this.batchSummary.filter(x => x.binName === 'Batch')[0];
    return Math.round(meltedtons * 100.0) / 100.0;
  }

  add(): void {
    this.batchSummaryService
      .getBinSummaryInfo(this.selectedPlant.id, this.selectedTank.id, moment(this.productionDate).format(Strings.ISO_DATE_FORMAT))
      .then(batchSummaryInfo => {

        let result = openAddBatchSummary({
          plant: this.selectedPlant,
          tank: this.selectedTank,
          productionDate: this.productionDate,
          batchSummaryInfo: batchSummaryInfo.map(bi => { bi.pounds = (bi.pounds ? bi.pounds : null); return bi; }),
        }, this.$modal);

        result.then(added => {
          if (!added) {
            return;
          }

          this.loaderService.loadingPromise(this.loadBatchSummary());
        });
      });
  }

  edit(instance: apsViewModels.BatchSummaryItem): void {
    this.batchSummaryService.getDetail(instance.id)
      .then(detail => {
        let result = openAddBatchSummary({
          plant: this.selectedPlant,
          tank: this.selectedTank,
          productionDate: this.productionDate,
          batchSummaryInfo: [detail],
        }, this.$modal);

        result.then(updated => {
          if (!updated) {
            return;
          }
          this.loaderService.loadingPromise(this.loadBatchSummary());
        });
      });
  }

  remove(instance: apsViewModels.BatchSummaryItem): void {
    this.uiUtilityService.confirm('Are you sure you want to delete this Summary Item?').then(confirmed => {
      if (!confirmed) {
        return;
      }

      this.loaderService.loadingPromise(this.batchSummaryService.remove({
        id: instance.id
      }).then(() => {
        this.loaderService.loadingPromise(this.loadBatchSummary());

      }, this.notifyService.handleApiErrors));
    });
  }

  createCountSummary(summaries: apsViewModels.BatchSummaryItem[],plant: string, tank: string ): apsViewModels.BatchSummaryItemExport[] {
    let report: apsViewModels.BatchSummaryItemExport[] = [];
    summaries.forEach(item => {
      let reportItem: apsViewModels.BatchSummaryItemExport = {
        plantName: plant,
        tankName: tank,
        commodityName: item.commodityName,
        binName: item.binName,
        pounds: item.pounds,
        tons: item.tons,
        productionDate: item.productionDate
      };
      report.push(reportItem);
    });
    return report;
  }

  exportToCsv() {
    let titles = [];
    titles.push("Plant", "Tank", "CommodityName","BinName", "Pounds", "GlassTons");
    
    let result = [];
    result.push(titles);
    if (this.currentselectedPlant && this.currentselectedTank && this.productionDate)
      return this.batchSummaryService
        .get(this.selectedPlant.id, this.selectedTank.id, moment(this.productionDate).format(Strings.ISO_DATE_FORMAT))
        .then(batchSummary => {
        let exportReport = this.createCountSummary(batchSummary,this.currentselectedPlant.name, this.currentselectedTank.name);
        exportReport.forEach(x => {
          result.push({
            plant:  x.plantName,
            tank: x.tankName,
            commodityName: x.commodityName,
            binName: x.binName,
            pounds : x.pounds,
            glassTons: x.tons
          });
        });
        return result;
      });
  }

  canBatchBeEdited(): boolean {
    const today = new Date(); 
    var currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    if(!this.productionDate || this.productionDate > currentDate) { return false; }
    var firBusMonth = this.productionDate.getMonth() === 11 ? 0 : this.productionDate.getMonth()+1;
    var firstBusDay = this.firstBusinessDay(firBusMonth);
     return (today.getMonth() >= this.productionDate.getMonth() || (today.getMonth() < this.productionDate.getMonth() && today.getFullYear() > this.productionDate.getFullYear())) && currentDate <= firstBusDay;
   }
  
   firstBusinessDay(month: number): Date {
    let first = moment().month(month).startOf('month');     
     while( ((first.day() % 7)) === 0 || (first.day() % 7) === 6) {
        first = first.add(1, 'd');
     }
   
     if(this.holidays.filter(h => h.date.getTime() === first.toDate().getTime()).length === 1) {
       first = first.add(1, 'd');
     }
     return first.toDate();
   }
}

export default angular.module('aps.controller.batchSummary', requires)
  .config(($stateProvider: angular.ui.IStateProvider) => {
    $stateProvider.state({
      name: States.BATCH_SUMMARY,
      url: '/admin/batchSummary',
      controller: 'BatchSummaryCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Batch Summary',
        authorizePlantAdmin: true,
        v2Uri: 'aps/settings/batch-summary'
      }
    });
  })
  .controller('BatchSummaryCtrl', BatchSummaryCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/batches/batchSummary.controller.ts